module.exports = __webpack_public_path__ + "static/media/Bot_Nova_Saludo.58bc8dc7.png";